import React from "react"

export const HeaderCell = ({ data, colSize }) => {
  return (
    <>
      {data.map((col, idx) => (
        <div
          key={col}
          scope="col"
          className={`
   
		font-inter
		${colSize ? colSize[idx] : "flex-1"}
		text-[12px]
   
		text-[#151124]
		font-semibold
		bg-white
		align-middle
		${idx ? "text-right" : "text-left"}
		  flex
		  items-end
		  
		table-cell
		font-normal
		uppercase 
		${idx > 0 ? "md:text-right" : ""}

		md:border-b-[2px]
		md:border-black 
		
			md:tracking-[0.12px]
			md:pb-[12px]
			  desk:trackgin-[0.16px]
			  desk:text-[16px] 
			  ${idx !== data.length - 1 ? "mr-[25px]" : ""}  
			`}
        >
          {col}
        </div>
      ))}
    </>
  )
}

export const TableHeader = ({ headerCols, colSize }) => {
  return (
    <div
      className={`
		  flex
		   
		  border-b
		  border-black
		  bg-white
		  sticky
		  top-0
		  align
		  
		  pt-[20px]
		  pb-[8px]
  
		  md:border-0
		  md:h-[32px]
		  table-row
		  md:flex-wrap
		  justify-between
		  w-100 `}
    >
      <HeaderCell data={headerCols /*bodyCols*/} colSize={colSize} />
    </div>
  )
}
